import React from 'react'
import flowRight from 'lodash/flowRight'
import { useMount } from 'react-nb-hooks'
import { LKDate } from 'loankeeper-common/helpers/Date'

import LKGrid from '../LKGrid'
import LKModal, { LKModalContainer, LKModalTrigger } from '../LKModal'

import translate from './translate'
import container from './container'

export const HISTORY_MODAL = 'HISTORY_MODAL'
export const HISTORY_GRID = 'HISTORY_GRID'

const LKGridconfig = {
  gridIdentity: {
    formName: 'frm_auth_loanevent_history',
    objectName: 'dbgrd_history',
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnDefs: [
    { headerName: 'AuthTypeID', field: 'AuthTypeID' },
    { headerName: 'AuthDate', field: 'AuthDate' },
    { headerName: 'LoginFull', field: 'LoginFull' },
    { headerName: 'AuthType', field: 'AuthType' },
  ],

  columnConfigs: {
    AuthDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toTString(),
    },
    AuthTypeID: {
      iconComponent: (value) => {
        switch (Number(value)) {
          case 1:
            return 'bullet_red'
          case 2:
            return 'bullet_green'
          default:
            return undefined
        }
      },
    },
  },
}

const HistoryModal = ({ modalInstanceName, getHistory, handleModalClose, loading }) => {
  const [history, setHistory] = React.useState([])

  useMount(() => {
    getHistory((value) => {
      setHistory(value)
    })

    return () => {
      handleModalClose()
    }
  })

  return (
    <LKModal
      icon="footprint"
      heading={translate('frm_auth_loanevent_history')}
      name={modalInstanceName}
      onClose={handleModalClose}
      loading={loading}
      size="xxs"
    >
      <LKGrid instanceName={HISTORY_GRID} rowData={history} {...LKGridconfig} />
    </LKModal>
  )
}

HistoryModal.defaultProps = {
  loading: true,
}

export const HistoryModalTrigger = ({ disabled, ...restProps }) => (
  <LKModalTrigger disabled={disabled} params={restProps} alias="footprint" name={HISTORY_MODAL} />
)

export default flowRight(LKModalContainer(HISTORY_MODAL), container, React.memo)(HistoryModal)
